export default __webpack_public_path__ + "static/media/visual.d321b381.png";